import React from 'react';
export function Footer() {
  return <footer className="px-6 md:px-12 lg:px-20 border-t border-ink/10" data-id="element-24" data-mp="32wd2cf6gdjt0">
      <div className="py-24 md:py-28 flex justify-center" data-id="element-25" data-mp="3ggarlxr3gh6i">
        <div className="label text-graphite/50 text-center" data-id="element-26" data-mp="32nul2myzi10u">
          {'Vera Wellness Co. · Est. 2025'}
        </div>
      </div>
    </footer>;
}